import React, { useState } from 'react'
import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { gradeAtom, gradeTagAtom } from '../GradeSelector/grade.atom'
import {
  generatedMetaStructureAtom,
  generatedSimpleTreeAtom,
} from '../../atoms'
import { LessonStructure } from '../../types'
import { ICourseNode, INodeList } from 'components/ingestion/IngestedTree'
import {
  createLessonPlan,
  createNodeList,
  createUnit,
} from 'ingestion/nodeCreationHelpers'
import { NodeType } from 'shared/types/ingestion'
import LoadingButton from '@mui/lab/LoadingButton'
import { Update } from '@mui/icons-material'
import { getLessonNodes } from '../helpers/utility'
import { selectedSubjectAtom } from '../SubjectSelector/subject.atom'
import { selectedAttributionAtom } from '../AttributionSelector/attribution.atom'

function SimplifiedTreeGenerator() {
  const [_, setCourse] = useAtom(generatedSimpleTreeAtom)
  const [generating, setGenerating] = useState(false)
  const metaStructure = useAtomValue(generatedMetaStructureAtom)
  const grade = useAtomValue(gradeAtom)
  const gradeTag = useAtomValue(gradeTagAtom)
  const selectedSubject = useAtomValue(selectedSubjectAtom)
  const selectedAttribution = useAtomValue(selectedAttributionAtom)

  const getTreeStructure = async (
    lessons: LessonStructure[],
  ): Promise<ICourseNode> => {
    const unitsArray = lessons.map((lesson) => lesson.unit)
    const unitsSet = [...new Set(unitsArray)]

    const units = await Promise.all(
      unitsSet.map(async (unit) => {
        const lessonsRows = lessons.filter((lesson) => lesson.unit === unit)

        const lessonArray = await Promise.all(
          lessonsRows.map(async (lesson) => {
            const nodes = await getLessonNodes(lesson)

            return createLessonPlan(
              {
                title: `Lesson ${lesson.id}: ${lesson.name}`,
              },
              nodes,
            )
          }),
        )

        const nodeList = createNodeList(
          {
            title: 'Lessons',
          },
          lessonArray,
        )
        return createUnit('Unit ' + unit, [nodeList])
      }),
    )

    units.sort((a, b) => a.data.title.localeCompare(b.data.title))
    const nodeList: INodeList = createNodeList(
      {
        title: 'Units',
      },
      units,
    )

    const tree: ICourseNode = {
      type: NodeType.Course,
      data: {
        subjectID: selectedSubject.subject_id,
        gradeID: grade + 1,
        title: `SC Math Grade ${gradeTag}`,
        attribution: selectedAttribution,
      },
      nodes: [nodeList],
    }
    return tree
  }

  const generatingSimplifiedTreee = async () => {
    const tree = await getTreeStructure(metaStructure.lessons)
    setCourse(tree)
    setGenerating(false)
  }

  return (
    <LoadingButton
      variant="contained"
      onClick={() => {
        setGenerating(true)
        generatingSimplifiedTreee()
      }}
      loading={generating}
      color="primary"
      startIcon={<Update />}
    >
      Generate Simplified Tree
    </LoadingButton>
  )
}

export default SimplifiedTreeGenerator
